/* eslint-disable camelcase */
import React, { Component } from 'react';
import Loader from 'lib/loader'

export default class PlanSettings extends Component {
  constructor(props) {
    super(props);
    const dataProps = props.location && props.location.state ? props.location.state : {}
    console.log(props)
    this.state = {
      errorMessage: {},
      userName: null,
      loadData: false,
      params: dataProps.params || {},
      trackAnalytics: dataProps.trackAnalytics || {}
    };
    // console.log(window.heap.addUserProperties({test:""}))
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props){
    const dataProps = props.location && props.location.state ? props.location.state : {}
    this.setState({ params: dataProps.params || {}, trackAnalytics: dataProps.trackAnalytics || {} })
  }

  componentDidMount() {
    this.loadData();
  }

  onClickNext() {
    const errorMessage = this.state.errorMessage;
    const { params, trackAnalytics } = this.state;
    const { often_meal_plan, meal_prep_experience, enough_saving_time_to_plan, user_cooking_style } = this.state.params;
    this.setState({ loadData: true})
    if (often_meal_plan !== undefined && 
        meal_prep_experience !== undefined && 
        enough_saving_time_to_plan !== undefined && 
        user_cooking_style!== undefined ) {
      const email = localStorage.getItem('email')
      window.analytics.track('New Signup Basic Settings', {
        'id':email,
        'Plan Frequency': trackAnalytics.often_meal_plan,
        'Prep Experience': trackAnalytics.meal_prep_experience,
        'Cook Style': trackAnalytics.user_cooking_style,
        'Web Experience': trackAnalytics.enough_saving_time_to_plan,
      });
      window.heap.addUserProperties({
        'id':email,
        'Plan Frequency': trackAnalytics.often_meal_plan,
        'Prep Experience': trackAnalytics.meal_prep_experience,
        'Cook Style': trackAnalytics.user_cooking_style,
        'Web Experience': trackAnalytics.enough_saving_time_to_plan,
      })
      console.log(window.heap)
      this.props.onClickNext(params);
    } else {
      if (!often_meal_plan) {
        errorMessage.often_meal_plan = 'Please select your meal plan duration';
      } else {
        errorMessage.often_meal_plan = false;
      }
      if (!meal_prep_experience) {
        errorMessage.meal_prep_experience = 'Please select your meal prep experience';
      } else {
        errorMessage.meal_prep_experience = false;
      }
      if (!user_cooking_style) {
        errorMessage.user_cooking_style = 'Please select your last few months cooking style';
      } else {
        errorMessage.user_cooking_style = false;
      }
      if (!enough_saving_time_to_plan) {
        errorMessage.enough_saving_time_to_plan = 'Please select your option';
      } else {
        errorMessage.enough_saving_time_to_plan = false;
      }
      
      this.setState({ errorMessage, loadData: false });
    }
  }


  async loadData() {
    const userName = await localStorage.getItem('firstName');
    this.setState({userName});
    const data = await sessionStorage.getItem('guestAccount') ?
      JSON.parse(sessionStorage.getItem('guestAccount')) : null;
    if (data && data.mealPlan) {
      this.setState(data.mealPlan);
    }
  }

  updateValue(event,value, trackValue){
    const { params, trackAnalytics } = this.state
    params[event.target.name] = value
    trackAnalytics[event.target.name] = trackValue
    this.setState({ params, trackAnalytics })
  }

  render() {
    const { errorMessage, userName, loadData } = this.state;
    return (
      <section className="main-cntnt slidetest" style={{right: '-300px'}}>
        <div className="container" style={{ marginBottom: '80px' }}>
          <div className="main-cntnt-box">
            {
              loadData &&
              <div className="loading">
                <Loader />
                <div className="modal-backdrop fade in" />
              </div>
            }
            <h2 className="mb-hide">Great! Nice to Meet You {userName}</h2>
            <h2 className="mb-only">Great! Nice to meet you {userName}!</h2>
            <p className="hdng-para">We just need to know a couple things to get you started.</p>
            <div className="main-cntnt-inner">
              <div className="col-xs-12 col-md-4 intro-sectn">
                <div className="timeline">
                  <div className='timeline-row'>
                    <div className="timeline-content">
                      <span />
                      <p>Your Account</p>
                    </div>
                  </div>
                  <div className='timeline-row active'>
                    <div className="timeline-content">
                      <span />
                      <p>The Basics</p>
                    </div>
                  </div>
                  
                  <div className='timeline-row'>
                    <div className="timeline-content">
                      <span />
                      <p>Meal Plan Style</p>
                    </div>
                  </div>
                  <div className='timeline-row last-row-timeline'>
                    <div className="timeline-content">
                      <span />
                      <p>Build Your First Plan</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-8 login-sectn">
                <div>
                  <div className="row">
                    <h4 className="mb-only text-left new-step-mb">Step 2: Meal Plan Preferences</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-12 form-row">
                      <p
                        className={errorMessage.often_meal_plan ?
                          'inner-check-row-hdng error-label' : 'nner-check-row-hdng'}
                      >
                        How often do you meal plan?
                      </p>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist name="often_meal_plan" onChange={(event) => this.updateValue(event,'1 week per month', '1 week')}/>
                          <span className="checkmark" />1 week per month.
                        </label>
                      </div>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist name="often_meal_plan" onChange={(event) => this.updateValue(event,'2 weeks per month', '2 weeks')}/>
                          <span className="checkmark" />2 weeks per month.
                        </label>
                      </div>
                    
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist name="often_meal_plan" onChange={(event) => this.updateValue(event,'3 weeks per month', '3 weeks')}/>
                          <span className="checkmark" />3 weeks per month.
                        </label>
                      </div>
                    
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist name="often_meal_plan" onChange={(event) => this.updateValue(event,'4 weeks per month','4 weeks')}/>
                          <span className="checkmark" />4 weeks per month.
                        </label>
                      </div>
                    
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist name="often_meal_plan" onChange={(event) => this.updateValue(event,'Every couple months', 'Infrequent')}/>
                          <span className="checkmark" />Every couple months.
                        </label>
                      </div>
                    
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist name="often_meal_plan" onChange={(event) => this.updateValue(event,'I don`t want to meal plan', 'None')}/>
                          <span className="checkmark" />I don't want to meal plan.
                        </label>
                      </div>
                    
                    
                    </div>
                  </div>
                
                  <div className="row">
                    <div className="col-md-12 form-row">
                      <p
                        className={errorMessage.meal_prep_experience ?
                          'inner-check-row-hdng error-label' : 'nner-check-row-hdng'}
                      >
                        What's your experience with meal prep? 
                      </p>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="meal_prep_experience" onChange={(event) => this.updateValue(event,'I`m trying meal prep for the first time','Beginner')}/>
                          <span className="checkmark" />I'm trying meal prep for the first time.
                        </label>
                      </div>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="meal_prep_experience" onChange={(event) => this.updateValue(event,'I have meal prepped a few times in the past','Moderate')}/>
                          <span className="checkmark" />I have meal prepped a few times in the past.
                        </label>
                      </div>
                    
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="meal_prep_experience" onChange={(event) => this.updateValue(event,'I have meal prepped 5+ times', 'Experienced')}/>
                          <span className="checkmark" />I have meal prepped 5+ times.
                        </label>
                      </div>
                    
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="meal_prep_experience" onChange={(event) => this.updateValue(event,'I don`t want to meal prep', 'None')}/>
                          <span className="checkmark" />I don't want to meal prep.
                        </label>
                      </div>
                    
                    </div>
                  </div>
                
                  <div className="row">
                    <div className="col-md-12 form-row">
                      <p
                        className={errorMessage.user_cooking_style ?
                          'inner-check-row-hdng error-label' : 'nner-check-row-hdng'}
                      >
                        What has been your cooking style over the last few months? 
                      </p>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="user_cooking_style" onChange={(event) => this.updateValue(event,'Cook Fresh: make meals right before eating them','Cook Fresh')}/>
                          <span className="checkmark" />
                            Cook Fresh: make meals right before eating them.
                        </label>
                      </div>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="user_cooking_style" onChange={(event) => this.updateValue(event,'Ingredient Prep: cook or chop ingredients ahead of time and cook meals right before eating', 'Ingredient Prep')}/>
                          <span className="checkmark" /> 
                            Ingredient Prep: cook or chop ingredients ahead of time and cook meals right before eating.
                        </label>
                      </div>
                    
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="user_cooking_style" onChange={(event) => this.updateValue(event,'Partial Meal Prep: cook some meals ahead of time for the week and cook some meals right before eating', 'Partial Prep')}/>
                          <span className="checkmark" />
                            Partial Meal Prep: cook some meals ahead of time for the week and cook some meals right before eating.
                        </label>
                      </div>
                    
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="user_cooking_style" onChange={(event) => this.updateValue(event,'Full Meal Prep: cook most meals for the week ahead of time', 'Full Prep')}/>
                          <span className="checkmark" />
                            Full Meal Prep: cook most meals for the week ahead of time.
                        </label>
                      </div>
                    
                    </div>
                  </div>
                
                  <div className="row">
                    <div className="col-md-12 form-row">
                      <p
                        className={errorMessage.enough_saving_time_to_plan ?
                          'inner-check-row-hdng error-label' : 'nner-check-row-hdng'}
                      >
                        Is saving time on cooking healthy meals important enough that you would pay for a better
                        way to plan and prep food for the week?
                      </p>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="enough_saving_time_to_plan" onChange={(event) => this.updateValue(event,'Yes, I`m willing to create meal plans on my computer','Yes')}/>
                          <span className="checkmark" />
                            Yes, I'm willing to create meal plans on my computer.
                        </label>
                      </div>
                      <div className="check-row">
                        <label className="container1 rbutton">
                          <input type="radio" data-hj-whitelist  name="enough_saving_time_to_plan" onChange={(event) => this.updateValue(event,'No, I`m not willing to use a computer for meal planning','No')}/>
                          <span className="checkmark" /> 
                            No, I'm not willing to use a computer for meal planning
                        </label>
                      </div>
                    
                    </div>
                  </div>
                
                  <div className="row">
                    <div className="form-row text-right cnfrm-btn-box col-md-12">
                      <button className="next-btn" onClick={() => this.onClickNext()}> Next </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/register/PlanSettings.js